import axios from 'axios'

const API = axios.create({
    baseURL:'http://d239564j45.zicp.vip/apaas/backend/apaas/west-satisfied',
    timeout:5000,
    headers:{
        'Content-Type':'application/json'
    }
})

export default API